<template>
  <SettingsPageLayout>
    <div v-if="loaded" class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
      <Card>
        <div class="h-48 flex flex-col justify-between">
          <div>
            <div class="flex justify-between">
              <div>
                <h3 class="text-lg font-medium leading-6 text-gray-900 mr-2">
                  New Unlicensed Candidate with Coursework Started
                </h3>
              </div>
              <ToggleInput
                @update:modelValue="updateNotifyUnlicensedCandidateCourseworkStarted($event)"
                :modelValue="team.notifyUnlicensedCandidateCourseworkStarted"
              />
            </div>
            <p class="mt-1 text-sm text-gray-500">
              When an Unlicensed Candidate with Coursework Started applies for any job, Humaniz sends them a message
              from your team to schedule a phone screen.
            </p>
          </div>
          <div class="flex justify-between">
            <TButton class="invisible" label="Settings" color="white" @click="showDisqualifiedCandidateSettings = true">
            </TButton>
            <div class="mt-2">
              <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">
                Email
              </span>
              <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                SMS
              </span>
            </div>
          </div>
        </div>
      </Card>

      <Card>
        <div class="h-48 flex flex-col justify-between">
          <div>
            <div class="flex justify-between">
              <div>
                <h3 class="text-lg font-medium leading-6 text-gray-900 mr-2">New Unlicensed Candidate</h3>
              </div>
              <ToggleInput
                @update:modelValue="updateNotifyUnlicensedCandidate($event)"
                :modelValue="team.notifyUnlicensedCandidate"
              />
            </div>
            <p class="mt-1 text-sm text-gray-500">
              When an Unlicensed Candidate applies for any job, Humaniz sends them a message from your team configured
              in the settings.
            </p>
          </div>
          <div class="flex justify-between">
            <TButton label="Settings" color="white" @click="showNewUnlicensedCandidateSettings = true"> </TButton>
            <div class="mt-2">
              <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">
                Email
              </span>
              <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                SMS
              </span>
            </div>
          </div>
        </div>
      </Card>

      <Card>
        <h3 class="text-lg font-medium leading-6 text-gray-900 mr-2">Need a workflow?</h3>
        <p class="mt-1 text-sm text-gray-500">
          Feel free to email us at support@humaniz.io with any workflow ideas you may have. We will get to building them
          right away!
        </p>
      </Card>
    </div>

    <DisqualifiedCandidateSettings
      v-if="showDisqualifiedCandidateSettings"
      @handleCancelSettings="showDisqualifiedCandidateSettings = false"
      @handleSaveSettings="showDisqualifiedCandidateSettings = false"
    />
    <NewUnlicensedCandidateSettings
      v-if="showNewUnlicensedCandidateSettings"
      @handleCancelSettings="showNewUnlicensedCandidateSettings = false"
      @handleSaveSettings="showNewUnlicensedCandidateSettings = false"
    />
  </SettingsPageLayout>
</template>

<script>
import SettingsPageLayout from '../../SettingsPageLayout/index.vue';
import Card from '../../Card/index.vue';
import DisqualifiedCandidateSettings from './settings/DisqualifiedCandidateSettings.vue';
import NewUnlicensedCandidateSettings from './settings/NewUnlicensedCandidateSettings.vue';

export default {
  components: {
    SettingsPageLayout,
    Card,
    DisqualifiedCandidateSettings,
    NewUnlicensedCandidateSettings,
  },
  data() {
    return {
      loaded: false,
      team: {
        id: '',
        notifyUnlicensedCandidateCourseworkStarted: false,
        notifyUnlicensedCandidate: false,
      },
      showNewUnlicensedCandidateSettings: false,
      showDisqualifiedCandidateSettings: false,
    };
  },
  mounted() {
    this.getTeam();
  },
  methods: {
    handleCancelSettings() {
      const self = this;
      self.showSettings = false;
    },
    handleSaveSettings() {
      const self = this;
      self.showSettings = false;
    },
    getTeam() {
      const self = this;
      self.$store.commit('general/showLoadingSpinner');
      fetch(`/api/teams/1`)
        .then(response => {
          self.$store.commit('general/hideLoadingSpinner');
          return response.json();
        })
        .then(data => {
          self.team.id = data.id;
          self.team.notifyUnlicensedCandidateCourseworkStarted =
            data.record.unlicensed_candidate_notification_coursework_started;
          self.team.notifyUnlicensedCandidate = data.record.unlicensed_candidate_notification;
          self.loaded = true;
        });
    },
    updateNotifyUnlicensedCandidateCourseworkStarted(e) {
      const self = this;
      self.team.notifyUnlicensedCandidateCourseworkStarted = e;
      self.$store.commit('general/showLocalLoadingSpinner');
      fetch(`/api/teams/${self.team.id}`, {
        method: 'PUT',
        body: JSON.stringify({
          unlicensed_candidate_notification_coursework_started: e,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          self.$store.commit('general/hideLocalLoadingSpinner');
          if (data.status != 'error') {
            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'Workflow updated',
              alertDescription: 'Your workflow was successfully updated.  Use the button below to dismiss this alert.',
            });
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Workflow update error',
              alertDescription: data.message,
            });
          }
        });
    },
    updateNotifyUnlicensedCandidate(e) {
      const self = this;
      self.team.notifyUnlicensedCandidate = e;
      self.$store.commit('general/showLocalLoadingSpinner');
      fetch(`/api/teams/${self.team.id}`, {
        method: 'PUT',
        body: JSON.stringify({
          unlicensed_candidate_notification: e,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          self.$store.commit('general/hideLocalLoadingSpinner');
          if (data.status != 'error') {
            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'Workflow updated',
              alertDescription: 'Your workflow was successfully updated.  Use the button below to dismiss this alert.',
            });
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Workflow update error',
              alertDescription: data.message,
            });
          }
        });
    },
  },
};
</script>
